import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'checkRoute'
})
export class CheckRoutePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (window.location.pathname === '/' || window.location.pathname === '/login'
      || window.location.pathname === '/login1'
      || window.location.pathname === '/pa' || window.location.pathname === '/404') { return false; }
    return true;
  }

}
